import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { GetCareNowFormatService } from '../../../utilities/getcarenow-format.service';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-virtual-urgent-care-option-card',
  imports: [CommonModule, TranslateModule, MatCardModule, MatButtonModule],
  templateUrl: './virtual-urgent-care-option-card.component.html',
  styleUrls: ['./virtual-urgent-care-option-card.component.css']
})
export class VirtualUrgentCareOptionCardComponent {
  @Input() providerId!: string;
  @Input() specialtyId!: string;
  @Input() name!: string;
  @Input() specialties!: string;
  @Input() availability!: string;
  @Input() photo!: string;
  @Input() websiteUrl: string | null = null;
  @Input() locale: string | null = null;

  private getCareNowFormatService: GetCareNowFormatService;

  public soonAsText: string = 'AS_SOON_AS';
  public virtualVisitText: string = 'DESCRIPTION';
  public scheduleText: string = 'SCHEULE';
  public today: string = 'TODAY';
  public tomorrow : string = 'TOMORROW';  
  public waitTime: string = '';

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
      this.translate.use(sessionStorage.getItem("locale") || 'en-US'); // Default to 'en-US' if no locale is provided
      this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
    }
    
  
    ngOnInit(): void {
  
      this.waitTime = this.getCareNowFormatService.formatNextAvailability(this.availability);
  
     this.translate.get('BOOK_AS_SOON_AS').subscribe((translated: string) => {
        this.soonAsText = translated;
      });
  
      this.translate.get('VIRTUAL_VISIT').subscribe((translated: string) => {
        this.virtualVisitText = translated;
      });
  
      this.translate.get('SCHEDULE').subscribe((translated: string) => {
        this.scheduleText = translated;
      });
    }

    bookNow() {
      const eptID = sessionStorage.getItem("eptID");
      const isMobile = window.location.href.includes('mobile');
      
      if (eptID == null || eptID == undefined || eptID == "") {
        this.bookNowUnAuth(); 
      }
      else {
        this.bookNowAuth();
      }
    }

    bookNowUnAuth() {
      // web deep link for unauthenticated users to generic VUC provider with both peds and adult visit types
      // https://mymemorialcaretst19.memorialcare.org/MyChartTST/openscheduling/standalone?id=7000892&vt=52216,52220
      
      var deepLink = environment.web_open_scheduling_deep_link_base_url
        + "/standalone?id=" + this.providerId
        + "&vt=" + environment.adult_vuc_rfv_id
        +  "&linksource=PLUAVUC";

      this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'get-care-now', subfeature: 'VUC', platform: 'web' }); // log as web event

      console.log("VUC Now clicked (IPUC)");
      console.log(deepLink);
      window.location.href = deepLink;
    }
  
    bookNowAuth() {
      var deepLink = "";
      const age = sessionStorage.getItem("age");
      var ageNumber = age ? parseInt(age) : null;
  
      deepLink = environment.web_scheduling_deep_link_base_url + "?workflow=NewProvider&selProvId=" + this.providerId;
        
      // add provider id and reason for visit id params to the deep link
      if (ageNumber != null) {
        deepLink += ageNumber < 18 
          ? "&selRfvId="+ environment.pediatric_vuc_rfv_id
          : "&selRfvId="+ environment.adult_vuc_rfv_id;
      }
      
      if (this.specialtyId && this.specialtyId.trim() !== "") {
    
        deepLink += `&selSpecialtyId=${this.specialtyId}`;
      }

      deepLink += "&linksource=AUTHVUCSCHED";
          
      console.log("book now clicked (VUC)");
      console.log(deepLink);
        
      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'VUC', platform: 'web' }); // log as web event

      window.location.href = deepLink;
    }
  
    formatNextAvailability(availability: string): string {
      return this.getCareNowFormatService.formatNextAvailability(availability);
    }
}
